<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="3" height="15" viewBox="0 0 3 15">
  <g fill="none">
    <g [attr.fill]="color">
      <path d="M1.5 3C0.7 3 0 2.3 0 1.5 0 0.7 0.7 0 1.5 0 2.3 0 3 0.7 3 1.5 3 2.3 2.3 3 1.5 3ZM1.5 9C0.7 9 0 8.3 0 7.5 0 6.7 0.7 6 1.5 6 2.3 6 3 6.7 3 7.5 3 8.3 2.3 9 1.5 9ZM1.5 15C0.7 15 0 14.3 0 13.5 0 12.7 0.7 12 1.5 12 2.3 12 3 12.7 3 13.5 3 14.3 2.3 15 1.5 15Z"/>
    </g>
  </g>
</svg>